<template>
  <div>
    <b-card
      no-body
      class="mb-1"
      v-for="(item, index) in qualifications"
      :key="item.id"
    >
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button
          block
          v-b-toggle="'accordion-qualification-' + index"
          variant="info"
        >
          <span v-if="!item.isCompleted">Stage three Qualification</span>
          <span v-if="item.isCompleted">Qualification {{getDate(item.createdDateTime)}}</span>
        </b-button>
      </b-card-header>
      <b-collapse
        :id="'accordion-qualification-' + index"
        visible
        accordion="accordion"
        role="tabpanel"
      >
        <b-card-body>
          <b-card-text>
            <CompanyQualificationEntry
              :initialQualification="item"
              :lookups="lookups"
              :index="index"
            />
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <CompanyTransferCreateModal :companyId="selectedCompanyId" ref="companyTransferCreateModal"/>
  </div>
</template>

<script>
import CompanyQualificationEntry from "@/components/company/qualification/CompanyQualificationEntry.vue";
import CompanyTransferCreateModal from "@/components/shared/CompanyTransferCreateModal.vue";
import { format } from 'date-fns'

export default {
  components: { CompanyQualificationEntry, CompanyTransferCreateModal },
  props: {
    company: Object,
    lookups: Object,
    qualifications: Array
  },
  methods: {
    transferCompany(companyId) {
      this.selectedCompanyId = companyId;
      this.$refs.companyTransferCreateModal.showModal();
    },
    getDate(date) {
      if(date == null) return "";
      return format(new Date(date), "dd/MM/yyyy HH:mm")
    }
  },
  data() {
    return {
      selectedCompanyId: null,
    };
  },
};
</script>


<style scoped>
.table {
  font-size: 0.85em;
}

.label {
  text-align: right;
}
.label > label {
  margin-top: 6px;
}
</style>

